import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TermsAndConditionsComponent } from '../terms-and-conditions/terms-and-conditions.component';
import * as EmailValidator from 'email-validator';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { InterestDialogComponent } from '../interest-dialog/interest-dialog.component';
import { IndustryDialogComponent } from '../industry-dialog/industry-dialog.component';
import { Subject, debounceTime } from 'rxjs';
import { first, last } from 'lodash';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ZipcodeConfirmationDialogComponent } from '../zipcode-confirmation-dialog/zipcode-confirmation-dialog.component';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import { noNumericAfterDotComValidator } from 'src/app/shared/numeric-after-dot-validator';
import { patternForm } from 'src/app/shared/constants/constants';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss'],
})
export class RegistrationFormComponent implements OnInit {
  registerForm!: FormGroup;
  emailPattern = patternForm.emailPattern;
  mobilePattern = patternForm.mobilePattern;
  emailValid = false;
  userExist = false;
  baseUrl = environment.BASE_URL;
  documentInfo = {
    userType: 'Customer',
    documentUseFor: 'brochure',
    baseUrl: this.baseUrl,
  };
  fileUploadedData: any;
  fileUploadConfig = {
    buttonName: 'Upload Brochure/Presentation',
    fileSizeLimit: 10485760, // 10 mb in bytes
    fileFormats: '.xls, .xlsx, .pdf, .doc, .docx, .zip, .ppt', // supported file formats for file picker
  };
  industryData: any[] = [];
  countryData: any[] = [];
  stateData: any[] = [];
  cityData: any[] = [];
  countryCodes: any[] = [];
  categoryData: any[] = [];
  flag = false;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  phoneForm = new FormGroup({
    mobile: new FormControl(undefined, [Validators.required]),
  });
  input: any;
  stepDisabled: boolean = false;
  managementLevels: any = [];
  departments: any = [];
  sourceManagement: any = [];
  selectedYear!: number;
  yearOptions: number[] = [];
  timelineList: any = [];
  turnOvers: any = [];
  files: any = [];
  selectedInterestsList: any = [];
  showStateCitySelect: boolean = false;
  showHStateCitySelect: boolean = false;
  categories = [
    {
      name: 'Category 1',
      items: [
        { id: 1, name: 'Item 1A' },
        { id: 2, name: 'Item 1B' },
      ],
    },
    {
      name: 'Category 2',
      items: [
        { id: 3, name: 'Item 2A' },
        { id: 4, name: 'Item 2B' },
      ],
    },
    // Add more categories as needed
  ];

  interestData: any[] = [];

  // map the groupBy field with category column
  groupFields: Object = { groupBy: 'Category', text: 'Vegetable', value: 'Id' };
  // set the placeholder to the MultiSelect input
  groupWaterMark: string = 'Select vegetables';
  show: boolean = true;
  isSupplierShow: boolean = false;
  companySizeList: any = [];
  interestsList: any = [];
  industryList: any = [];
  headquarterstateData: any[] = [];
  headquarterCityData: any[] = [];
  developmentPayload: boolean = true;
  uniqueInterestIds = new Set<number>();
  headQuaterForm: FormGroup = new FormGroup({});
  fullAddress: any[] = [];
  fullAddressHeadQuarter: any;
  sampleData: any;
  private zipDebouncer$: Subject<string> = new Subject();
  private zipDebouncerHeadquarter$: Subject<string> = new Subject();
  searchZipcode = '';
  searchZipcodeHeadquarter = '';
  sampleDataHeadQuarter: any;
  isDialogOpen: boolean = false;
  connectionFailedPopupActive: boolean = false;
  changePreferredCountries() {
    this.preferredCountries = [CountryISO.India, CountryISO.Canada];
  }

  constructor(
    public fb: FormBuilder,
    private service: CommonService,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private http: HttpClient,
    private gtmService: GoogleTagManagerService,
  ) {}

  ngOnInit() {
    this.initializeYearOptions();
    this.getTimelineData();
    this.getManagementLevel();
    this.getDepartments();
    this.getIndustry();
    this.getsoucrceOfSupplier();
    this.getTurnOver();
    this.getCompanySize();
    this.getInterests();
    this.getCountry();

    this.getInterest();
    this.createRegistratrionForm();
    // this.getState();
    // this.getCity();
    // this.setupSearchDebouncer();
    // this.setupSearchDebouncerHeadquarter();
    

    this.otherValidation();
    this.checkUserExist()
  }
  createRegistratrionForm(){
    this.registerForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(4)]],
      companyEmail: [
        '',
        [Validators.required, Validators.email, noNumericAfterDotComValidator()],
      ],
      countryCode: ['+91', Validators.required],
      mobile: '',
      company: ['', Validators.required],
      lastName: ['', [Validators.required]],
      department: ['', [Validators.required]],
      departmentOthers: ['', Validators.required],
      isDevelopment: ['1', Validators.required],
      sourceManagement: '',
      sourceManagementOthers: '',
      title: ['', [Validators.required]],
      isSupplier: false,
      publicLister: false,
      termsAndConditions: [false, Validators.required],
    });
  }
  otherValidation(){
    this.registerForm.controls['department'].valueChanges.subscribe((value) => {
      if (value[1] === 'others') {
        this.registerForm.controls['departmentOthers'].setValidators(Validators.required);
      } else {
        this.registerForm.controls['departmentOthers'].clearValidators();
      }
      this.registerForm.controls['departmentOthers'].updateValueAndValidity();
    });
  }
  checkUserExist(){
    this.registerForm.controls['companyEmail'].valueChanges.subscribe(
      () => (this.userExist = false),
    );
  }
  checkFieldValue(formControlName:string){
    if(this.registerForm?.get(formControlName)?.value[1] == 'Others' || this.registerForm?.get(formControlName)?.value[1] == 'others'){
      return true
    } else{
      return false
    }
    
  }
  
 
  pushEmailIdEvent() {
    const gtmTag = {
      event: 'Customer_Onboarding-Step-1',
      event_category: 'User Input',
      user_email: this.registerForm.value?.companyEmail.toLowerCase() || '',
      phone_no: this.registerForm.value.mobile.e164Number,
      name:
        this.registerForm.value?.title +
        ' ' +
        this.registerForm.value?.name +
        ' ' +
        this.registerForm.value?.lastName,
      user_type: 'Customer',
      step_name: 'Onboarding_step1',
      screen_name: 'Customer Registration',
    };
    this.gtmService.pushTag(gtmTag);
  }

  pushSecondStepEvents() {
    const gtmTag = {
      event: 'Customer_Onboarding-Step-2',
      event_category: 'User Input',
      step_2: 'completed',
    };
    this.gtmService.pushTag(gtmTag);
  }

  pushThirdStepEvents() {
    const gtmTag = {
      event: 'Customer_Onboarding-Step-3',
      event_category: 'User Input',
      step_3: 'completed',
    };
    this.gtmService.pushTag(gtmTag);
  }

  openConnectionFailedPopup(event?: any): void {
    this.connectionFailedPopupActive = !this.connectionFailedPopupActive;
    event?.preventDefault();
    document.body.classList.add('rfqboxOpen');
  }

  closeconnectionFailedPopup(event?: any): void {
    this.connectionFailedPopupActive = !this.connectionFailedPopupActive;
    document.body.classList.remove('rfqboxOpen');
  }

  // getIndustry() {
  //   this.service.getData(`${this.baseUrl}common-service/industry-management`).subscribe((res: any) => {
  //     this.industryData = res?.response;
  //   })
  // }
  // otherValidation(event:any, fieldItem:any){
  //   //const selectedValue = event.value;
  //   const formControlName = event.source.ngControl.name;
  //   let otherFieldName = fieldItem.replace(/^"(.*)"$/, '$1');

  //   this.registerForm.controls[formControlName].valueChanges.subscribe((value) => {
  //     if (value[1] === 'others') {
  //       this.registerForm.controls[otherFieldName].setValidators(Validators.required);
  //     } else {
  //       this.registerForm.controls[otherFieldName].clearValidators();
  //     }
  //     this.registerForm.controls[otherFieldName].updateValueAndValidity();
  //   });
  // }
  getManagementLevel() {
    let apiUrl = `${this.baseUrl}common-service/management-level`;
    this.service.getData(apiUrl).subscribe({
      next: (res: any) => {
        if (res?.status?.responseStatus) {
          this.managementLevels = res.response;
        }
      },
      error: (e: HttpErrorResponse) => {
        if (e.status == 0) {
          this.openConnectionFailedPopup();
        }
        this.toastr.error(e.error.status.error.message);
      },
    });
  }

  fileUploadEvent(fileUploadEvent: any) {
    // this.documentInfo = fileUploadEvent;
    this.fileUploadedData = fileUploadEvent;
  }

  getDepartments() {
    let apiUrl = `${this.baseUrl}common-service/functional-department`;
    this.service.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.departments = res.response;
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }

  getsoucrceOfSupplier() {
    let apiUrl = `${this.baseUrl}common-service/source-management`;
    this.service.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.sourceManagement = res.response;
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }

  interestValidation: boolean = false;
  interestValidationText = '';
  InterestValidation() {
    interface Interest {
      id: number;
      interestValues: [];
    }
    const intetestArray: Interest[] = this.interestsList;
    this.interestsList.forEach((listofinterest: Interest) => {
      this.uniqueInterestIds.add(listofinterest.id);
    });
    this.interestData.forEach((_list: any) => {
      this.uniqueInterestIds.delete(_list.interestId);
    });
    if (this.uniqueInterestIds.size > 0) {
      this.interestValidation = true;
      // alert('please select interest from all category');
    } else {
      this.interestValidation = false;
    }
  }

  getEmailStatus() {
    if (this.registerForm.value.companyEmail) {
      this.service
        .getData(
          `${this.baseUrl}auth-service/user-management/getUserDetailByEmail?emailId=${this.registerForm.value.companyEmail}`,
        )
        .subscribe((res) => {
          if (res?.response.userExist) {
            this.toastr.warning('User Already Exists');
            this.flag = true;
          }
        });
    }
  }
  updateFlag() {
    this.flag = false;
  }
  get validateEmail() {
    return EmailValidator.validate(this.registerForm.value.companyEmail);
  }

  isAlreadyExists() {
    if (this.registerForm?.value?.companyEmail == "") {
      return;
    }
    if (window.location.host == 'unibuild.ai' && this.registerForm?.value?.companyEmail?.includes('yopmail.com')) {
      this.toastr.error('Not a valid email domain');
      return;
    }
    let apiurl = `${this.baseUrl}auth-service/user-management/getUserDetailByEmail?emailId=${this.registerForm.value.companyEmail}`;
    this.service
      .getData(apiurl)
      .pipe(debounceTime(1000))
      .subscribe({
        next: (data: any) => {
          if (!data?.response?.userExist) {
            this.emailValid = true;
            this.userExist = false;
            // this.registerForm.controls['companyEmail'].setErrors(null)
          } else {
            this.emailValid = false;
            this.userExist = true;
            this.registerForm.controls['companyEmail'].setErrors({ incorrect: true });
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error?.error?.status?.error?.identifier);
        },
      });
  }

  getCompanySize() {
    let apiUrl = `${this.baseUrl}common-service/company-size`;
    this.service.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.companySizeList = res.response;
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }

  onToggleChange(event: any) {
    const slideToggle = event.source as MatSlideToggle; // Cast the event source to MatSlideToggle
    this.show = slideToggle.checked;
    if (this.show) {
      this.headQuaterForm = new FormGroup({});
    } else {
      this.headQuaterForm = this.fb.group({
        isHeadquarters: true,
        headquartersCountry: ['', Validators.required],
        headquartersState: ['', Validators.required],
        headquartersCity: ['', Validators.required],
        headquartersPincode: ['', Validators.required],
        headquartersAddress: ['', Validators.required],
      });
      this.getHeadquarterState();
      this.getHeadquarterCity();
    }

    // Perform actions based on the toggle state (slideToggle.checked)
  }

  isSupplierToggle(event: any) {
    const slideToggle = event.source as MatSlideToggle; // Cast the event source to MatSlideToggle
    this.isSupplierShow = slideToggle.checked;
    this.registerForm.controls['isSupplier'].patchValue(slideToggle.checked);
  }

  register() {
    // this.getSelectedIndustryList();
    // this.selectedIndustryList.forEach((item: any) => {
    //   item.sectors = `[${item.sectors}]`;
    // });
    // // this.getSelectedInterests();
    // this.selectedInterestsList.forEach((item: any) => {
    //   item.interestValues = `[${item.interestValues}]`;
    // });

    // if (this.registerForm.value.isDevelopment == '1') {
    //   this.developmentPayload = true;
    // } else {
    //   this.developmentPayload = false;
    // }
    // let state =
    //   typeof this.registerForm?.value?.state == 'string'
    //     ? this.registerForm?.value?.state
    //     : last(this.registerForm?.value?.state);
    // let city =
    //   typeof this.registerForm?.value?.city == 'string'
    //     ? this.registerForm?.value?.city
    //     : last(this.registerForm?.value?.city);
    // let hState =
    //   typeof this.headQuaterForm.value?.headquartersState == 'string'
    //     ? this.headQuaterForm.value?.headquartersState
    //     : last(this.headQuaterForm.value?.headquartersState);
    // let hCity =
    //   typeof this.headQuaterForm.value?.headquartersCity == 'string'
    //     ? this.headQuaterForm.value?.headquartersCity
    //     : last(this.headQuaterForm.value?.headquartersCity);

    const registrationFormValue = this.registerForm.value;

    const payload1 = {
      userDetail: {
        userName:
          registrationFormValue.title +
          registrationFormValue.name +
          registrationFormValue.lastName,
        email: registrationFormValue.companyEmail.toLowerCase(),
        status: true,
        phone: registrationFormValue.mobile.e164Number,
        userType: 'Customer',
        source: 'WEB',
        role: 'Customer',
        title: registrationFormValue.title,
        firstName: registrationFormValue.name.trim(),
        lastName: registrationFormValue.lastName.trim(),
        functionalDepartmentId: registrationFormValue.department[0],
        functionalDepartmentName: registrationFormValue.department[1],
        functionalDepartmentOther: registrationFormValue.departmentOthers,
        company: registrationFormValue.company.trim(),
        countryCode: registrationFormValue.mobile.countryCode
      },
      customerCompanyProfile: {
        name: registrationFormValue.company.trim(),
        source: registrationFormValue.sourceManagement[1],
        otherSource: registrationFormValue.sourceManagementOthers,
      },
    };
    localStorage.setItem('customeremail', this.registerForm.value.companyEmail);
    localStorage.setItem('customeruser-details', JSON.stringify(payload1.userDetail));
    localStorage.setItem(
      'customer-company-profile',
      JSON.stringify(payload1.customerCompanyProfile),
    );

    
    this.service
      .postDatawithoutHeaders(`${this.baseUrl}auth-service/sendOtp`, {
        email: this.registerForm.value.companyEmail.toLowerCase(),
        userName: this.registerForm.value.name,
      })
      .subscribe((res) => {
        this.pushEmailIdEvent();
        this.router.navigateByUrl('/registration/otp-verify');
      });
  }

  awsBasicUploadSingle(url: string) {
    const bucketUrl = url.split('?');

    const HttpUploadOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
    };

    let formParams = new FormData();

    formParams.append('file', this.files[0]);

    this.http.put(url, formParams, HttpUploadOptions).subscribe({
      next: (data: any) => {
        // this.fileUploadForm.reset();

        this.toastr.success(`File uploaded successfully at ${bucketUrl[0]}`);
      },

      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      },
    });
  }

  getFileUploadS3UrlAndUpload() {
    const filesData = {
      fileName: this.files[0].name,

      type: this.files[0].type,

      updatedById: '1',
    };

    this.service
      .postDatawithoutHeaders(`${this.baseUrl}auth-service/uploadDocuments`, filesData)
      .subscribe({
        next: (data: any) => {
          this.awsBasicUploadSingle(data.response);
        },

        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.status.error.message);
        },
      });
  }

  prepareFilesList(files: any) {
    this.files = files.target.files;
  }

  getCountry() {
    this.service
      .getData(`${this.baseUrl}common-service/country-management`)
      .subscribe((res) => {
        this.countryData = res?.response;
      });
  }

  getInterests() {
    this.service
      .getData(`${this.baseUrl}common-service/interest-management`)
      .subscribe((res) => {
        this.interestsList = res?.response;
      });
  }

  selectedIndustryList: any = [];
  getSelectedIndustryList() {
    let selectedIndustries = this.registerForm.value.industry;
    this.industryData.forEach((item: any) => {
      if (item && item.sectors)
        item.sectors.forEach((val: any) => {
          if (selectedIndustries.length)
            selectedIndustries.forEach((x: any) => {
              if (
                x[0] == val.sectorId &&
                this.selectedIndustryList.some((y: any) => y.industryId == item.id)
              ) {
                this.selectedIndustryList
                  .find((z: any) => z.industryId == item.id)
                  ?.sectors.push(x[0]);
              } else if (
                x[0] == val.sectorId &&
                !this.selectedIndustryList.some((y: any) => y.industryId == item.id)
              ) {
                let obj = {
                  industryId: item.id,
                  industryName: item.industryName,
                  sectors: [x[0]],
                };
                this.selectedIndustryList.push(obj);
              }
            });
        });
    });
  }

  // getSelectedInterests() {
  //   let selectedInterests = this.registerForm.value.interest;
  //   this.interestsList.forEach((item: any) => {
  //     item.interestValues.forEach((val: any) => {
  //       selectedInterests.forEach((x: any) => {
  //         if (x[0] == val.id && this.selectedInterestsList.some((y: any) => y.interestId == item.id)) {
  //           this.selectedInterestsList.find((z: any) => z.interestId == item.id)?.interestValues.push(x[0]);
  //         } else if (x[0] == val.id && !this.selectedInterestsList.some((y: any) => y.interestId == item.id)) {
  //           let obj = {
  //             interestId: item.id,
  //             name: item.name,
  //             interestValues: [x[0]]
  //           };
  //           this.selectedInterestsList.push(obj);
  //         }
  //       })
  //     })
  //   })
  // }

  getState() {
    this.registerForm?.get('country')?.valueChanges.subscribe((x: any[]) => {
      if (x.length > 0)
        this.showStateCitySelect = first(x) == 101 || first(x) == 105 ? true : false; // enable select dropdown for state for China and HongKong
      this.service
        .getData(`${this.baseUrl}common-service/state-management?countryId=${first(x)}`)
        .subscribe((res) => {
          this.stateData = res?.response;
          this.getCity();
        });
      // this.cityData = [];
      // this.registerForm?.get('city')?.reset();
    });
  }

  getHeadquarterState() {
    this.headQuaterForm
      ?.get('headquartersCountry')
      ?.valueChanges.subscribe((x: any[]) => {
        this.showHStateCitySelect = first(x) == 101 || first(x) == 105 ? true : false; // enable select dropdown for state for China and HongKong
        this.service
          .getData(`${this.baseUrl}common-service/state-management?countryId=${first(x)}`)
          .subscribe((res) => {
            this.headquarterstateData = res?.response;
            this.getHeadquarterCity();
          });
        // this.headquarterCityData = [];
        // this.headQuaterForm?.get('headquartersCity')?.reset();
      });
  }

  getCity() {
    this.registerForm?.get('state')?.valueChanges.subscribe((x) => {
      if (x !== null && x !== undefined) {
        let stateId = this.stateData.find((state) => state?.stateName == x[1])?.id;
        if (stateId !== undefined) {
          this.service
            .getData(`${this.baseUrl}common-service/city-management?stateId=${stateId}`)
            .subscribe((res) => {
              this.cityData = res?.response;
            });
        }
      }
    });
    // if(this.showStateCitySelect){
    // this.registerForm?.get('state')?.valueChanges.subscribe(x =>
    //   this.service.getData(`${this.baseUrl}common-service/city-management?stateId=${first(x)}`).subscribe(res => {
    //     this.cityData = res?.response;
    //   }));
    // }
  }

  getHeadquarterCity() {
    this.headQuaterForm?.get('headquartersState')?.valueChanges.subscribe((x) => {
      if (x !== null && x !== undefined) {
        let stateIds = this.headquarterstateData.find(
          (states) => states?.stateName === x[1],
        )?.id;
        if (stateIds !== undefined) {
          this.service
            .getData(`${this.baseUrl}common-service/city-management?stateId=${stateIds}`)
            .subscribe((res) => {
              this.headquarterCityData = res?.response;
            });
        }
      }
    });
  }

  getCategory() {
    this.service
      .getData(`${this.baseUrl}common-service/category-management`)
      .subscribe((res) => {
        this.categoryData = res?.response;
      });
  }
  getTermsAndConditions() {
    const dialogRef = this.dialog.open(TermsAndConditionsComponent);
  }

  getTimelineData() {
    this.service.getData(`${this.baseUrl}common-service/timeline`).subscribe((res) => {
      this.timelineList = res?.response;
    });
  }

  initializeYearOptions(): void {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 100; // Change the number of years as needed

    for (let year = currentYear; year >= startYear; year--) {
      this.yearOptions.push(year);
    }
  }
  isValid() {
    if (
      !this.registerForm.value.termsAndConditions ||
      this.registerForm.controls['name'].status === 'INVALID' ||
      this.registerForm.controls['lastName'].status === 'INVALID' ||
      this.registerForm.controls['companyEmail'].status === 'INVALID' ||
      this.registerForm.controls['mobile'].status === 'INVALID' ||
      this.registerForm.value.mobile == null ||
      this.flag ||
      this.registerForm.controls['company'].status === 'INVALID' ||
      this.registerForm.controls['title'].status === 'INVALID' ||
      this.registerForm.controls['department'].status === 'INVALID' ||
      this.registerForm.controls['departmentOthers'].status === 'INVALID'
    ) {
      return true;
    } else {
      return false;
    }
  }
  isValidSave() {
    if (
      this.industryData.length == 0 ||
      this.registerForm.controls['address'].status === 'INVALID' ||
      this.registerForm.controls['country'].status === 'INVALID' ||
      this.registerForm.controls['state'].status === 'INVALID' ||
      this.registerForm.controls['city'].status === 'INVALID' ||
      this.registerForm.controls['pincode'].status === 'INVALID' ||
      this.headQuaterForm?.invalid
    ) {
      return true;
    } else {
      return false;
    }
  }

  isValidRegister(): boolean {
    if (
      !this.registerForm.value.termsAndConditions ||
      this.registerForm.controls['establishmentYear'].value === '' ||
      this.registerForm.controls['establishmentYear'].value === undefined ||
      //this.registerForm.controls['website'].status === 'INVALID' ||
      this.registerForm.value.turnover == 0 ||
      this.registerForm.controls['turnover'].value === undefined ||
      this.registerForm.controls['companySize'].status === 'INVALID' ||
      this.isValid() ||
      this.isValidSave()
    ) {
      this.stepDisabled = true;
      return true;
    } else {
      this.stepDisabled = false;
      return false;
    }
  }

  isPhoneValid(error: any): String {
    if (error != null && !error.validatePhoneNumber.valid) {
      return 'Phone number is not valid';
    } else {
      return '';
    }
  }
  isPhoneRequired(error: any): String {
    if (error == null) {
      return 'Mobile number is required';
    } else {
      return '';
    }
  }

  getTurnOver() {
    let apiUrl = `${this.baseUrl}common-service/turnover`;
    this.service.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.turnOvers = res.response;
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }
  openDialog(): void {
    this.dialog
      .open(InterestDialogComponent, {
        // width: '500px',
        // position: { right: '30%' },
        data: {
          data: JSON.parse(JSON.stringify(this.interestsList)),
          editable: true,
        },
      })
      .afterClosed()
      .subscribe({
        next: (res: any) => {
          if (res.isTrue) {
            this.setInterest(res.data);
            this.InterestValidation();
          }
        },
      });
  }
  getInterest() {
    let apiUrl = `${this.baseUrl}common-service/interest-management`;
    this.service.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.interestsList = res.response;
        this.interestsList.forEach((interest: any) => {
          interest.interestValues = interest.interestValues.map((values: any) => {
            values['isChecked'] = false;
            return values;
          });
        });
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }
  setInterest(data: any) {
    this.interestsList = JSON.parse(JSON.stringify(data));
    this.interestData = [];

    data.forEach((interest: any) => {
      let interestValues: any[] = [];
      interest.interestValues.forEach((values: any) => {
        if (values.isChecked) {
          interestValues.push(values.id);
        }
      });
      // let count = interestValues.length
      if (interestValues.length > 0) {
        this.interestData.push({
          interestId: interest.id,
          name: interest.name,
          interestValues: interestValues,
        });
      }
    });
  }
  openIndustryDialog(): void {
    this.dialog
      .open(IndustryDialogComponent, {
        // width: '500px',
        // position: { right: '30%' },
        data: {
          data: JSON.parse(JSON.stringify(this.industryList)),
          editable: true,
        },
      })
      .afterClosed()
      .subscribe({
        next: (res: any) => {
          if (res.isTrue) {
            this.setIndustry(res.data);
          }
        },
      });
  }
  getIndustry() {
    let apiUrl = `${this.baseUrl}common-service/industry-management`;
    this.service.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.industryList = res.response;
        this.industryList.forEach((industry: any) => {
          industry.sectors = industry.sectors.map((values: any) => {
            values['isChecked'] = false;
            return values;
          });
        });
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }
  setIndustry(data: any) {
    this.industryList = JSON.parse(JSON.stringify(data));
    this.industryData = [];

    data.forEach((industry: any) => {
      let sectors: any[] = [];
      industry.sectors.forEach((values: any) => {
        if (values.isChecked) {
          sectors.push(values.sectorId);
        }
      });
      // let count = interestValues.length
      if (sectors.length > 0) {
        this.industryData.push({
          industryId: industry.id,
          industryName: industry.industryName,
          sectors: sectors,
        });
      }
    });
  }

  zipCountryCode: String = '';

  // SearchData() {
  //   if (this.registerForm.value.pincode.length >= 3 && this.registerForm.value.country) {
  //     this.service
  //       .getData(
  //         `${this.baseUrl}auth-service/geo-code?address=${this.registerForm.value.pincode}`,
  //       )
  //       .subscribe((res) => {
  //         let data = res;
  //         this.fullAddress = data.results[0]?.address_components;
  //         if (this.fullAddress !== undefined) {
  //           this.fullAddress.forEach((x: any) => {
  //             if (x.types[0] == 'country') {
  //               this.countryData.forEach((i: any) => {
  //                 if (i.id == this.registerForm.value.country[0]) {
  //                   this.zipCountryCode = i.countryCode;
  //                 }
  //               });
  //               if (
  //                 this.registerForm.value.country[1] !== x.long_name &&
  //                 this.zipCountryCode !== x.short_name
  //               ) {
  //                 this.registerForm?.get('state')?.reset();
  //                 this.registerForm?.get('city')?.reset();
  //                 this.findZipCodeData();
  //               }
  //             }
  //             if (x.types[0] == 'administrative_area_level_1') {
  //               this.registerForm.get('state')?.patchValue(x.long_name);
  //             }
  //             if (x.types[0] == 'administrative_area_level_2') {
  //               this.registerForm.get('city')?.patchValue(x.long_name);
  //             } else if (x.types[0] == 'locality') {
  //               this.registerForm.get('city')?.patchValue(x.long_name);
  //             }
  //           });
  //         } else {
  //           this.findZipCodeData();
  //         }
  //       });
  //   } else if (this.registerForm.value.pincode?.length == 0) {
  //     this.registerForm?.get('city')?.reset();
  //     this.registerForm?.get('state')?.reset();
  //   }
  // }

  onChangeCountry() {
    this.getState();
    this.registerForm?.get('city')?.reset();
    this.registerForm?.get('state')?.reset();
    this.registerForm?.get('pincode')?.reset();
    this.registerForm?.get('country')?.valueChanges.subscribe((x: any[]) => {
      if (x.length > 0)
        this.showStateCitySelect = first(x) == 101 || first(x) == 105 ? true : false;
    });
  }

  // headquarter
  SearchDataHeadQuarter() {
    if (
      this.headQuaterForm.value.headquartersPincode.length >= 3 &&
      this.headQuaterForm.value.headquartersCountry
    ) {
      this.service
        .getData(
          `${this.baseUrl}auth-service/geo-code?address=${this.headQuaterForm.value.headquartersPincode}`,
        )
        .subscribe((res) => {
          let data = res;
          this.fullAddressHeadQuarter = data.results[0]?.address_components;
          if (this.fullAddressHeadQuarter !== undefined) {
            this.fullAddressHeadQuarter.forEach((x: any) => {
              if (x.types[0] == 'country') {
                this.countryData.forEach((i: any) => {
                  if (i.id == this.headQuaterForm.value.headquartersCountry[0]) {
                    this.zipCountryCode = i.countryCode;
                  }
                });
                if (this.headQuaterForm.value.headquartersCountry[1] !== x.long_name) {
                  this.headQuaterForm?.get('headquartersCity')?.reset();
                  this.headQuaterForm?.get('headquartersState')?.reset();
                  this.findZipCodeDataHeadquarter();
                }
              }
              if (x.types[0] == 'administrative_area_level_1') {
                this.headQuaterForm.get('headquartersState')?.patchValue(x.long_name);
              }
              if (x.types[0] == 'administrative_area_level_2') {
                this.headQuaterForm.get('headquartersCity')?.patchValue(x.long_name);
              } else if (x.types[0] == 'locality') {
                this.headQuaterForm.get('headquartersCity')?.patchValue(x.long_name);
              }
            });
          } else {
            this.findZipCodeDataHeadquarter();
          }
        });
    } else if (this.headQuaterForm.value.pincode?.length == 0) {
      this.headQuaterForm?.get('headquartersState')?.reset();
      this.headQuaterForm?.get('headquartersState')?.reset();
    }
  }

  onChangeCountryHeadQuarter() {
    this.getHeadquarterState();
    this.headQuaterForm?.get('headquartersCity')?.reset();
    this.headQuaterForm?.get('headquartersState')?.reset();
    this.headQuaterForm?.get('headquartersPincode')?.reset();
    this.headQuaterForm
      ?.get('headquartersCountry')
      ?.valueChanges.subscribe((x: any[]) => {
        this.showHStateCitySelect = first(x) == 101 || first(x) == 105 ? true : false;
      });
  }

  zipcodeConfirmation() {
    if (!this.isDialogOpen) {
      this.isDialogOpen = true;
      const dialogRef = this.dialog.open(ZipcodeConfirmationDialogComponent, {
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result == false) {
          this.registerForm?.get('city')?.reset();
          this.registerForm?.get('state')?.reset();
          this.registerForm?.get('pincode')?.reset();
        } else if (result == true) {
          this.registerForm?.get('city')?.reset();
          this.registerForm?.get('state')?.reset();
        }
        this.isDialogOpen = false;
      });
    }
  }

  setupSearchDebouncer() {
    this.zipDebouncer$.pipe(debounceTime(1500)).subscribe((term: string) => {
      this.searchZipcode = term;
      // this.SearchData();
    });
  }
  searchSupplierzip(): void {
    this.searchZipcode = this.registerForm.value.pincode;
    this.zipDebouncer$.next(this.searchZipcode);
  }

  saveNewZipCode() {
    const payload = this.showStateCitySelect
      ? {
          countryId: this.registerForm.value.country[0],
          countryName: this.registerForm.value.country[1],
          stateName: this.registerForm.value.state[1],
          cityName: this.registerForm.value.city[1],
          pinCode: this.registerForm.value.pincode,
        }
      : {
          countryId: this.registerForm.value.country[0],
          countryName: this.registerForm.value.country[1],
          stateName: this.registerForm.value.state,
          cityName: this.registerForm.value.city,
          pinCode: this.registerForm.value.pincode,
        };
    const apiURL = `${this.baseUrl}common-service/pincode-management`;
    this.service.postDatawithoutHeaders(apiURL, payload).subscribe((res: any) => {});
    this.saveNewZipCodeHeadquarter();
  }

  findZipCodeData() {
    this.service
      .getData(
        `${this.baseUrl}common-service/pincode-management?countryId=${this.registerForm.value.country[0]}&countryName=${this.registerForm.value.country[1]}&pinCode=${this.registerForm.value.pincode}`,
      )
      .subscribe((res) => {
        this.sampleData = res?.response;
        if (this.sampleData?.stateName !== null) {
          this.registerForm.get('state')?.patchValue(this.sampleData?.stateName);
          this.registerForm.get('city')?.patchValue(this.sampleData?.cityName);
        } else {
          this.zipcodeConfirmation();
        }
      });
  }

  // ........

  zipcodeConfirmationHeadquarter() {
    if (!this.isDialogOpen) {
      this.isDialogOpen = true;
      const dialogRef = this.dialog.open(ZipcodeConfirmationDialogComponent, {
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result == false) {
          this.headQuaterForm?.get('headquartersCity')?.reset();
          this.headQuaterForm?.get('headquartersState')?.reset();
          this.headQuaterForm?.get('headquartersPincode')?.reset();
        } else if (result == true) {
          this.headQuaterForm?.get('headquartersCity')?.reset();
          this.headQuaterForm?.get('headquartersState')?.reset();
        }
        this.isDialogOpen = false;
      });
    }
  }

  setupSearchDebouncerHeadquarter() {
    this.zipDebouncerHeadquarter$.pipe(debounceTime(1500)).subscribe((term: string) => {
      this.searchZipcodeHeadquarter = term;
      this.SearchDataHeadQuarter();
    });
  }
  searchSupplierZipHeadquarter(): void {
    this.searchZipcodeHeadquarter = this.headQuaterForm.value.pincode;
    this.zipDebouncerHeadquarter$.next(this.searchZipcodeHeadquarter);
  }

  saveNewZipCodeHeadquarter() {
    if (this.headQuaterForm.value.isHeadquarters == true) {
      let payload = this.showHStateCitySelect
        ? {
            countryId: this.headQuaterForm.value.headquartersCountry[0],
            countryName: this.headQuaterForm.value.headquartersCountry[1],
            stateName: this.headQuaterForm.value.headquartersState[1],
            cityName: this.headQuaterForm.value.headquartersCity[1],
            pinCode: this.headQuaterForm.value.headquartersPincode,
          }
        : {
            countryId: this.headQuaterForm.value.headquartersCountry[0],
            countryName: this.headQuaterForm.value.headquartersCountry[1],
            stateName: this.headQuaterForm.value.headquartersState,
            cityName: this.headQuaterForm.value.headquartersCity,
            pinCode: this.headQuaterForm.value.headquartersPincode,
          };
      const apiURL = `${this.baseUrl}common-service/pincode-management`;
      this.service.postDatawithoutHeaders(apiURL, payload).subscribe((res: any) => {});
    }
  }
  findZipCodeDataHeadquarter() {
    this.service
      .getData(
        `${this.baseUrl}common-service/pincode-management?countryId=${this.headQuaterForm.value.headquartersCountry[0]}&countryName=${this.headQuaterForm.value.headquartersCountry[1]}&pinCode=${this.headQuaterForm.value.headquartersPincode}`,
      )
      .subscribe((res) => {
        this.sampleDataHeadQuarter = res?.response;
        if (this.sampleDataHeadQuarter?.stateName !== null) {
          this.headQuaterForm
            .get('headquartersState')
            ?.patchValue(this.sampleDataHeadQuarter?.stateName);
          this.headQuaterForm
            .get('headquartersCity')
            ?.patchValue(this.sampleDataHeadQuarter?.cityName);
        } else {
          this.zipcodeConfirmationHeadquarter();
        }
      });
  }
}
